module.exports = __webpack_public_path__ + "img/icon-order.41609368.svg";